import { SolicitudDesembolsoService } from 'app/services/operaciones/solicitud-desembolso/solicitud-des.service';
import { Component, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmpresasService } from '../../services/empresas/empresas.service';
import { OperacionService } from '../../services/operaciones/operacion/operacion.service';
import { SafeUrlPipe } from '../../pipes/safe-url.pipe';
import Swal from "sweetalert2";
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesGeneral, MessagesStatus } from '../../models/messages';


@Component({
  selector: 'app-adjuntar-archivo-firmado',
  templateUrl: './adjuntar-archivo-firmado.component.html',
  styleUrls: ['./adjuntar-archivo-firmado.component.scss'],
  providers: [
    SafeUrlPipe, MessagesTitles, MessagesGeneral, MessagesStatus
  ]
})
export class AdjuntarArchivoFirmadoComponent{


  @Output() cerrarPopUpFirmado: EventEmitter<boolean>;
  @Output() refresh = new EventEmitter<boolean>();
  form: FormGroup;
  user: any;
  files: any[] = [];
  dataEnviar: any = {};
  filesB64: any;
  cantItems: number;
  loading: boolean;

  Codigo: any = 1;
  TipoAdjunto: any = [];
  CantidadItems: number = 1;
  IDCMarco: any;

  idSolicitudDesembolso: any;
  idConfirming: any;
  idPagare: any;
  flag: boolean;
  flagPagare: boolean;
  flagCO: boolean;
  dataSolicitudD: any;

  constructor(
    private msgTitle: MessagesTitles,
    private msgStatus: MessagesStatus,
    private empresasService: EmpresasService,
    private solicitudDesembolsoService: SolicitudDesembolsoService,
    private operacionServices: OperacionService) {

    let flagCM = (this.empresasService.dataContratoM == null || this.empresasService.dataContratoM == undefined || this.empresasService.dataContratoM == '');
    let flagPagareO = (this.empresasService.dataPagare == null || this.empresasService.dataPagare == undefined || this.empresasService.dataPagare == '');  
    let flagSD = (this.solicitudDesembolsoService.dataSolicitudD == null || this.solicitudDesembolsoService.dataSolicitudD == undefined || this.solicitudDesembolsoService.dataSolicitudD == '');  
    let flagCOO = (this.operacionServices.dataConfirming == null || this.operacionServices.dataConfirming == undefined || this.operacionServices.dataConfirming == '');  
    if (flagCM && flagPagareO && flagCOO) {
      this.flag = true;
      this.idSolicitudDesembolso = this.solicitudDesembolsoService.dataSolicitudD.idSolicitudDesembolso;
    } else if ( flagSD && flagCM && flagPagareO) {
      this.flagCO = true;
      this.idConfirming = this.operacionServices.dataConfirming.idConfirming;
    } else if(flagCM && flagCOO && flagSD){
      this.flagPagare = true;
      this.idPagare = this.empresasService.dataPagare.idPagare;
    }else{
      this.IDCMarco = this.empresasService.dataContratoM.IDCMarco;
    }
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.cerrarPopUpFirmado = new EventEmitter();
  }


  Guardar() {

    this.cantItems = this.files.length - 1;
    let i = 0;
    if (this.flag) {
      this.dataEnviar.Alta_Usuario = this.user.Usuario;
      this.dataEnviar.idSolicitudDesembolso = this.idSolicitudDesembolso;
    } else if(this.flagPagare){
      this.dataEnviar.Alta_Usuario = this.user.Usuario;
      this.dataEnviar.idPagare = this.idPagare;
    }else if(this.flagCO){
      this.dataEnviar.Alta_Usuario = this.user.Usuario;
      this.dataEnviar.idConfirming = this.idConfirming;
    } else {
      this.dataEnviar.Alta_Usuario = this.user.Usuario;
      this.dataEnviar.Estado = 'A';
      this.dataEnviar.IDCMarco = this.IDCMarco;
    }
    for (let p of this.files) {
      if (p.type != 'application/pdf') {
        Swal.fire({
          title: this.msgTitle.Error,
          text: 'El archivo ' + p.name + ' no es pdf',
          type: "warning",
          allowOutsideClick: false,
          heightAuto: false
        });
        return;
      }

      this.aBinario(this.files, i)
      i++;

    }

  }

  aBinario(fileList: any, index: any) {
    let file = fileList[index];
    let fileReader: FileReader = new FileReader();
    var base64;
    var archivo64;
    var self = this;
    fileReader.onload = function (fileLoadedEvent) {
      base64 = fileLoadedEvent.target['result'];
      archivo64 = base64.split(',', 2);
      self.filesB64 = archivo64[1];

      self.dataEnviar.pdf64 = self.filesB64;
      if (self.cantItems == index) {
        if (self.flag) {
          self.EnviarSD(self.dataEnviar)
        }else if(self.flagPagare){
          self.EnviarPagare(self.dataEnviar)
        }else if(self.flagCO){
          self.EnviarConfirming(self.dataEnviar)
        } else {
          self.Enviar(self.dataEnviar)
        }

      }
    };

    fileReader.readAsDataURL(file);

  }

  Enviar(dataEnviar: any) {
    Swal.fire({
      title: "Espere",
      text: "Guardando Archivo",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    this.empresasService.updateContratoMarco(dataEnviar)
      .subscribe(
        res => {
          Swal.fire({
            title: "Success",
            text: "Archivo registrado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(resp => {
            if (resp.value) {
              this.cerrarPopUpFirmado.emit();
              this.empresasService.dataContratoM = "";
              this.refresh.emit();
            }
          });
        }, (err: HttpErrorResponse) => {
          if (err.error instanceof ErrorEvent) {
            console.error("Error Event");
          } else {
            this.msgStatus.getMessage(err.status);
          }
          Swal.fire({
            title: this.msgTitle.Error,
            text: "ARCHIVO NO GUARDADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
      );
  }


  EnviarSD(dataEnviar: any) {

    Swal.fire({
      title: "Espere",
      text: "Guardando Archivo",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.solicitudDesembolsoService.altaSolicitudDesembolso(dataEnviar)
      .subscribe(
        res => {
          Swal.fire({
            title: "Success",
            text: "Archivo registrado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(resp => {
            if (resp.value) {
              this.cerrarPopUpFirmado.emit();
              this.solicitudDesembolsoService.dataSolicitudD = "";
              this.refresh.emit();
            }
          });
        }, (err1: HttpErrorResponse) => {
          if (err1.error instanceof ErrorEvent) {
            console.error("Error Event");
          } else {
            this.msgStatus.getMessage(err1.status);
          }
          Swal.fire({
            title: this.msgTitle.Error,
            text: "ARCHIVO NO GUARDADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
      );
  }

  EnviarConfirming(dataEnviar: any) {

    Swal.fire({
      title: "Espere",
      text: "Guardando Archivo",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.operacionServices.altaOperacionConfirming(dataEnviar)
      .subscribe(
        res => {
          Swal.fire({
            title: "Success",
            text: "Archivo registrado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(resp => {
            if (resp.value) {
              this.cerrarPopUpFirmado.emit();
              this.operacionServices.dataConfirming = "";
              this.refresh.emit();
            }
          });
        }, (err1: HttpErrorResponse) => {
          if (err1.error instanceof ErrorEvent) {
            console.error("Error Event");
          } else {
            this.msgStatus.getMessage(err1.status);
          }
          Swal.fire({
            title: this.msgTitle.Error,
            text: "ARCHIVO NO GUARDADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
      );
  }
  EnviarPagare(dataEnviar: any) {
    Swal.fire({
      title: "Espere",
      text: "Guardando Archivo",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.empresasService.updatePagare(dataEnviar)
      .subscribe(
        res => {
          Swal.fire({
            title: "Success",
            text: "Archivo registrado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(resp => {
            if (resp.value) {
              this.cerrarPopUpFirmado.emit();
              this.empresasService.dataPagare = "";
              this.refresh.emit();
            }
          });
        }, (err2: HttpErrorResponse) => {
          if (err2.error instanceof ErrorEvent) {
            console.error("Error Event");
          } else {
            this.msgStatus.getMessage(err2.status);
          }
          Swal.fire({
            title: this.msgTitle.Error,
            text: "ARCHIVO NO GUARDADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
      );
  }

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 20);
      }
    }, 100);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {

    if (files.length > this.CantidadItems || files.length + this.files.length > this.CantidadItems) {
      Swal.fire({
        title: this.msgTitle.Error,
        text: 'Máximo ' + this.CantidadItems + ' archivo',
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
      return
    }
    if (this.files.length >= this.CantidadItems) {
      Swal.fire({
        title: this.msgTitle.Error,
        text: 'Máximo ' + this.CantidadItems + ' archivo',
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
      return
    }

    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  CerrarVentana() {
    this.cerrarPopUpFirmado.emit();
    if (!this.flag) {
      this.empresasService.dataContratoM = '';
    }

  }


}
